var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediumPrice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "white",
    stroke: "#F9A72E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8532 17.0357C17.7057 16.6174 17.4364 16.2527 17.08 15.9887C16.7236 15.7247 16.2963 15.5734 15.8532 15.5543H12.8902C12.3008 15.5543 11.7356 15.7884 11.3188 16.2051C10.9021 16.6219 10.668 17.1871 10.668 17.7765C10.668 18.3658 10.9021 18.9311 11.3188 19.3478C11.7356 19.7646 12.3008 19.9987 12.8902 19.9987H15.8532C16.4425 19.9987 17.0078 20.2328 17.4245 20.6496C17.8413 21.0663 18.0754 21.6316 18.0754 22.2209C18.0754 22.8103 17.8413 23.3755 17.4245 23.7923C17.0078 24.209 16.4425 24.4431 15.8532 24.4431H12.8902C12.447 24.424 12.0198 24.2727 11.6633 24.0087C11.3069 23.7446 11.0376 23.38 10.8902 22.9617M14.3717 13.332V15.5543M14.3717 24.4431V26.6654",
    stroke: "#F9A72E",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8532 17.0357C27.7057 16.6174 27.4364 16.2527 27.08 15.9887C26.7236 15.7247 26.2963 15.5734 25.8532 15.5543H22.8902C22.3008 15.5543 21.7356 15.7884 21.3188 16.2051C20.9021 16.6219 20.668 17.1871 20.668 17.7765C20.668 18.3658 20.9021 18.9311 21.3188 19.3478C21.7356 19.7646 22.3008 19.9987 22.8902 19.9987H25.8532C26.4425 19.9987 27.0078 20.2328 27.4245 20.6496C27.8413 21.0663 28.0754 21.6316 28.0754 22.2209C28.0754 22.8103 27.8413 23.3755 27.4245 23.7923C27.0078 24.209 26.4425 24.4431 25.8532 24.4431H22.8902C22.447 24.424 22.0198 24.2727 21.6633 24.0087C21.3069 23.7446 21.0376 23.38 20.8902 22.9617M24.3717 13.332V15.5543M24.3717 24.4431V26.6654",
    stroke: "#F9A72E",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumPrice);
export default __webpack_public_path__ + "static/media/medium-price.74fb7857c2faaf1767cbf10de1e22b70.svg";
export { ForwardRef as ReactComponent };